import './style.scss';
import { Caption } from 'views/mutual/caption';
import { NotificationList } from '../notice/module/notificationList';
import { useHome } from './hooks';
import { PagePath } from 'constants/pagePath';
import { NavLink } from 'react-router-dom';
import { NotificationDeliveryTarget } from 'constants/notice';
import { ComponentControl } from 'views/mutual/componentControl';

export const Home = () => {
  const {
    isLoading,
    allNotificationList,
    allNotificationListMore,
    personalNotificationList,
    personalNotificationListMore,
  } = useHome();

  return (
    <div className="home">
      <div className="home_notification">
        <Caption label="全体へのお知らせ" />
        <ComponentControl
          componentName={NotificationList}
          noDataMessege={'お知らせはありません'}
          isLoading={isLoading}
          items={allNotificationList}
          previousPage={PagePath.Home}
        />
        {allNotificationListMore && (
          <NavLink
            className="home_notification_continue"
            to={PagePath.Notice}
            state={{
              deliveryTarget: NotificationDeliveryTarget.All,
            }}
          >
            お知らせの続きを見る
          </NavLink>
        )}
      </div>
      <div className="home_notification">
        <Caption label="あなたへのお知らせ" />
        <ComponentControl
          componentName={NotificationList}
          noDataMessege={'お知らせはありません'}
          isLoading={isLoading}
          items={personalNotificationList}
          previousPage={PagePath.Home}
        />
        {personalNotificationListMore && (
          <NavLink
            className="home_notification_continue"
            to={PagePath.Notice}
            state={{
              deliveryTarget: NotificationDeliveryTarget.Personal,
            }}
          >
            お知らせの続きを見る
          </NavLink>
        )}
      </div>
    </div>
  );
};
